module.exports = __webpack_public_path__ + "img/hexin2.db74c31b.png";